module.exports = __webpack_public_path__ + "img/Limite.e45386d7.png";